module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 8-f10c50a51c6f30628a9faac17a524d8d.jpg";